var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"list-item list-item--post"},[_c('router-link',{attrs:{"to":("/newsletter/" + (_vm.post.id))}},[_c('span',[_vm._v("Title: "),_c('h4',[_vm._v(_vm._s(_vm.post.title))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Description: "),_c('h5',[_vm._v(_vm._s(_vm.post.body))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c18b46c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostItem.vue
// module id = 67
// module chunks = 0